import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "constants/config";
import ReactDOM from "react-dom/client";

import "styles/styles.scss";
import "react-loading-skeleton/dist/skeleton.css";

import App from "./App";

if (import.meta.env.VITE_STAGE === "production") {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
